<template>
  <div class="field">
    <label class="label">{{ $t('schedule') }}</label>
    <div class="control">
      <div class="select is-fullwidth">
        <select :value="value" @change="$emit('input', $event.target.value)" required>
          <option disabled value="">{{ $t('selectDefault') }}</option>
          <option v-for="option in scheduleOptions" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
    <p class="help">{{ $t('apiChannel.scheduleHelp') }}</p>
  </div>
</template>

<script>
export default {
  name: 'ScheduleSelector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    scheduleOptions () {
      return [
        { value: '30s', label: this.$t('apiChannel.schedule30s') },
        { value: '1m', label: this.$t('apiChannel.schedule1m') },
        { value: '5m', label: this.$t('apiChannel.schedule5m') },
        { value: '15m', label: this.$t('apiChannel.schedule15m') },
        { value: '30m', label: this.$t('apiChannel.schedule30m') },
        { value: '1h', label: this.$t('apiChannel.schedule1h') },
        { value: '6h', label: this.$t('apiChannel.schedule6h') },
        { value: '12h', label: this.$t('apiChannel.schedule12h') },
        { value: '24h', label: this.$t('apiChannel.schedule24h') }
      ]
    }
  }
}
</script>
